import {
    BULK_ASSIGN_USERS_FAIL,
    BULK_ASSIGN_USERS_SUCCESS,
    FETCH_ASSIGNABLE_USERS_FAIL,
    FETCH_ASSIGNABLE_USERS_SUCCESS,
    FETCH_ASSIGNED_USERS_BY_EVENT_FAIL,
    FETCH_ASSIGNED_USERS_BY_EVENT_SUCCESS,
    FETCH_ASSIGNED_USERS_BY_MODULE_FAIL,
    FETCH_ASSIGNED_USERS_BY_MODULE_SUCCESS,
    REMOVE_ASSIGNMENT_FAIL,
    SET_ASSIGNMENTS_ERROR,
    SET_ASSIGNMENTS_LOADING,
    SET_ASSIGNMENTS_REMOVING,
    SET_ASSIGNMENTS_SUBMITTING,
} from "../actions/assignmentActions";

const initialState = {
    loading: false,
    submitting: false,
    removing: false,
    error: null,
    assignableUsers: [],
    assignedUsersByEvent: {},
    assignedUsersByModule: {},
    bulkResult: null,
    bulkResultContextKey: null,
};

export default function assignmentReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ASSIGNMENTS_LOADING:
            return { ...state, loading: action.payload };
        case SET_ASSIGNMENTS_SUBMITTING:
            return { ...state, submitting: action.payload };
        case SET_ASSIGNMENTS_REMOVING:
            return { ...state, removing: action.payload };
        case SET_ASSIGNMENTS_ERROR:
            return { ...state, error: action.payload };
        case FETCH_ASSIGNABLE_USERS_SUCCESS:
            return { ...state, assignableUsers: action.payload || [], error: null };
        case FETCH_ASSIGNED_USERS_BY_EVENT_SUCCESS:
            return {
                ...state,
                assignedUsersByEvent: {
                    ...state.assignedUsersByEvent,
                    [action.payload.eventId]: action.payload.users || [],
                },
                error: null,
            };
        case FETCH_ASSIGNED_USERS_BY_MODULE_SUCCESS:
            return {
                ...state,
                assignedUsersByModule: {
                    ...state.assignedUsersByModule,
                    [action.payload.moduleId]: action.payload.users || [],
                },
                error: null,
            };
        case BULK_ASSIGN_USERS_SUCCESS:
            return {
                ...state,
                bulkResult: action.payload.result,
                bulkResultContextKey: action.payload.contextKey,
                error: null,
            };
        case FETCH_ASSIGNABLE_USERS_FAIL:
        case FETCH_ASSIGNED_USERS_BY_EVENT_FAIL:
        case FETCH_ASSIGNED_USERS_BY_MODULE_FAIL:
        case BULK_ASSIGN_USERS_FAIL:
        case REMOVE_ASSIGNMENT_FAIL:
            return { ...state, error: action.payload };
        default:
            return state;
    }
}
